export enum RenderType {
  DEFAULT,
  DIGITAL_SHARE,
  PRINT,
}
